import React from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import { AssetsEntryCardContainer } from './assets-entry-cards-container';
import { useImageBannerContainerStyle } from '../../styles';

export const ImagesTopBannerComponent = ({
  i18n,
  aid,
  cid,
  oDataConfig,
  isAdsStudioAIGCMVPEnabled,
  isAIGCRegionRestricted,
  notificationApi,
  navigation,
  logger,
  permissions,
}) => {
  const classes = useImageBannerContainerStyle();
  return (
    <div className={mergeClasses('top-banner', classes.topBanner)}>
      <div className={classes.texts}>
        <div className={classes.pageName} role="heading" aria-level="1">
          {i18n.getString(_TL_('Images'))}
        </div>
        <div className={classes.descriptions}>
          {i18n.getString(_TL_('Add new images or find existing images.'))}
        </div>
      </div>
      <div className={classes.entryCard}>
        <AssetsEntryCardContainer
          isAdsStudioAIGCMVPEnabled={isAdsStudioAIGCMVPEnabled}
          isAIGCRegionRestricted={isAIGCRegionRestricted}
          notificationApi={notificationApi}
          i18n={i18n}
          aid={aid}
          cid={cid}
          logger={logger}
          oDataConfig={oDataConfig}
          navigation={navigation}
          permissions={permissions}
        />
      </div>
    </div>
  );
};

ImagesTopBannerComponent.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({}).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  isAIGCRegionRestricted: PropTypes.bool.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({}),
  }),
};

ImagesTopBannerComponent.defaultProps = {
  permissions: { dynamic: {} },
};
